<template>
  <div class="LegendItem" v-on:click="trigger">
    <img :src="require('@/assets/icons/' + (active ? 'visibility' : 'visibility_off') + '.svg')" class="LegendItem__showButton" alt="" :style="{'visibility': (isTriggerable == false ? 'hidden' : 'visible')}">
    <div>
      <img v-if="src" :src="require('@/assets/icons/' + src)" class="LegendItem__pin">
      <span>
        <span class="LegendItem__color" v-if="color" :style="[{'backgroundColor': color}]"></span>
        {{ label }}<span v-show="$store.state.activeIgo !== null" class="LegendItem__count">{{ igoFilteredCount }} /</span><span class="LegendItem__count">{{ count }}</span>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LegendItem',
  props: {
    'label': {
      type: String,
      default: ''
    },
    'isTriggerable': {
      type: Boolean,
      default: true
    },
    'color': {
      type: String,
      default: null
    },
    'src': {
      type: String,
      default: null
    },
    'iconTriggered': {
      type: String,
      default() {
        return this.icon
      }
    },
    'active': {
      type: Boolean,
      default: true
    },
    'count': {
      type: Number,
      default: 0
    },
    'countries': {
      type: Array,
      default: null
    }
  },

  computed: {
    lang: function () {
      return this.$store.state.language.lang
    },
    igoFilteredCount: function () {
      return this.$store.state.activeIgo != null ? this.countries.filter(iso => this.$igoPlaces[this.$store.state.activeIgo]['places'].includes(iso)).length : "";
    }
  },
  methods: {
    trigger() { this.$emit('clicked') }
  }
}
</script>

<style lang="less">

@import "../less/_var.less";

.LegendItem {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  font-size: 0.9em;
  color: #000;

  &[data-active=true]:hover { opacity: 0.8; }

  .LegendItem__pin {
    max-width: 22px;
    max-height: 22px;
    margin-right: 8px;
  }

  .LegendItem__showButton {
    width: 15px;
    margin-right: 6px;
    display: none;

    &[src*='off'] ~ div {
      text-decoration: line-through;
      opacity: 0.6;
    }
  }

  div {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    font-family: @font-secondary;

    > span {
      display: inline;

      .LegendItem__color {
        border-radius: 50%;
        display: inline-block;
        height: 10px;
        margin-right: 8px;
        width: 10px;
      }
      .LegendItem__count {
        color: #888;
        margin-left: 4px;
        font-size: @font-xs + 0.1em;
      }
    }
  }
}

</style>
